import * as React from "react";

import { Api } from "./Api";
import { useAuth } from "../contexts/auth/useAuth";

/**
 * Adds an Axios response interceptor that catches 401 responses from the
 * backend. A 401 here means our access token is no longer accepted (expired
 * past refresh, revoked, or never had the right roles), so we end the
 * session — Keycloak's redirect flow will pick the user up at the next
 * navigation.
 */
const ResponseInterceptor = (): React.ReactNode => {
  const auth = useAuth();

  const interceptorId = React.useRef<number | null>(null);
  React.useEffect(() => {
    interceptorId.current = Api.axios().interceptors.response.use(
      undefined,
      (error) => {
        if (error?.response?.status === 401) {
          auth.signout();
        }
        return Promise.reject(error);
      }
    );
  }, []);

  return null;
};

export { ResponseInterceptor }
